import React, { useEffect, createElement } from 'react';
import { HeroSection } from './HeroSection';
import { OpeningLead } from './OpeningLead';
import { PainSection } from './PainSection';
import { FailureSection } from './FailureSection';
import { MechanismSection } from './MechanismSection';
import { ProductIntro } from './ProductIntro';
import { BenefitsSection } from './BenefitsSection';
import { ProofSection } from './ProofSection';
import { OfferStack } from './OfferStack';
import { GuaranteeSection } from './GuaranteeSection';
import { UrgencySection } from './UrgencySection';
import { CloseSection } from './CloseSection';
import { Footer } from './Footer';
export function SalesPage() {
  useEffect(() => {
    // Inject Google Fonts
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,700&family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400;1,600;1,700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    // Meta Pixel
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript?.parentNode?.insertBefore(script, firstScript);
    }
    ;
    (window as any).fbq('init', '1436890408218834');
    (window as any).fbq('track', 'PageView');
    // noscript fallback
    const noscriptImg = document.createElement('img');
    noscriptImg.height = 1;
    noscriptImg.width = 1;
    noscriptImg.style.display = 'none';
    noscriptImg.src = 'https://www.facebook.com/tr?id=1436890408218834&ev=PageView&noscript=1';
    document.body.appendChild(noscriptImg);
    return () => {
      document.head.removeChild(link);
      document.body.removeChild(noscriptImg);
    };
  }, []);
  return <main className="min-h-screen w-full bg-[#FBF7F0] font-sans text-[#2D2D2D] selection:bg-[#D4603A]/20 selection:text-[#2D2D2D]" data-id="element-210">
      <HeroSection data-id="element-211" />
      <OpeningLead data-id="element-212" />
      <PainSection data-id="element-213" />
      <FailureSection data-id="element-214" />
      <MechanismSection data-id="element-215" />
      <ProductIntro data-id="element-216" />
      <BenefitsSection data-id="element-217" />
      <ProofSection data-id="element-218" />
      <OfferStack data-id="element-219" />
      <GuaranteeSection data-id="element-220" />
      <UrgencySection data-id="element-221" />
      <CloseSection data-id="element-222" />
      <Footer data-id="element-223" />
    </main>;
}